import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import Carousel from 'preact-flickity-component';
import Markup from 'preact-markup';
import { GetSafeImageUrl } from '../../utils/ApiUtil';
import { signal } from '@preact/signals';
import { Text } from 'preact-i18n';
import { Modal } from '../../newsearch/AeModal';

// can be read/set/rendered by any component who refers to expanded.value
const expanded = signal(false);

export const Toppers = props =>  {
    const [searchResp, setSearchResp] = useState(props.searchResp);

    var vals = searchResp.webPages.value;
    var rewrites = searchResp.Rewrites;
    var toppers = [];

    // add to toppers
    vals?.forEach((val) => {
        if(val.name && val.url) {
            addTopper(0, val.name, val.url, val.thumbnailUrl, rewrites, toppers);
            val.deepLinks?.forEach((dl) => {
                if(dl.name && dl.url) {
                    addTopper(1, dl.name, dl.url, null, rewrites, toppers);
                        // for now, take out level 2 deeplinks
                        // dl.deepLinks?.forEach((dldl) => {
                        // if(dldl.name && dldl.url) {
                        //     addTopper(2, dldl.name, dldl.url, null, rewrites, toppers);
                        // }
                    // })
                }
            })
        }
    })

    // sort it out by link length descending, then alphabetically
    let sorted = Object.entries(toppers).map((a,b) => {return a[1]});
    sorted.sort((a,b) => {return(b.links.length-a.links.length || a.hostname.localeCompare(b.hostname))});

    // drop this in a carousel
    return (
        <div className="ae-affsearch-wdg">
            <div className="ae-wdg-caption">
                <div className="ae-caption affsearchtitle">
                    <div className='aff-search-caption-wrap'>
                    <Text id="newSearch.quickLinkTitle">Quick Link Search Results</Text>
                    </div>
                </div>
            </div>
            <div className="toppers-block">
                <div className="ae-caption affsearchdisclaim" style={{display: "flex"}}>
                    <Text id="newSearch.quickLinkDisclaimer">We may sometimes receive payment for your qualified purchases through these links</Text>
                    <span className="aff-policy-info-icon" style={{position: "inherit"}}>
                        <Modal headerKey={"newSearch.quickLink"} textKey={"newSearch.quickLinkInfo"}/>
                    </span>
                </div>
                <div>
                    <Carousel expanded={expanded.value} options={{wrapAround: false, pageDots: false, percentPosition: false, cellAlign: props.isRightToLeft ? 'right' : 'left', rightToLeft: props.isRightToLeft}}>
                        {sorted.map(topper => {
                            return <Topper topper={topper}/>
                        })}
                    </Carousel>
                </div>
            </div>
        </div>
      
    )
}

function addTopper(pos, name, url, img, rewrites, toppers) {
    let u = new URL(url);
    let hostname = u.hostname.toLowerCase();
    if(hostname.startsWith("www.")) {
        hostname = hostname.substring(4);
    }
    let top = toppers[hostname];
    if(!top) {
        top = {hostname: hostname, links: []};
        toppers[hostname] = top;
    }
    // apply rewrites to the links
    let link = {pos: pos, name: name, url: rewrites[url] ? rewrites[url] : url, img: img};
    top.links.push(link);
}

export const Topper = props =>  {
    const [topper, setTopper] = useState(props.topper);

    const toggleExpanded = (e) => {
        e.stopPropagation();
        expanded.value = !expanded.value;
    }

    const handleTopperBlockClick = () => {
        if (expanded.value && topper.links.length > 1) { // if topper is expanded and has more than one link do nothing
            return;
        } else { // navigate to the first link 
            window.open(topper.links[0].url);
        }
    }

    if(!topper) {
        return (""); //defensive check
    }

    // give google links to hostname images
    // dropdown for links.length > 1
    // click and name for things with == 1
    return (
        <div className="topper-wrapper">
            <div className="ae-border-box-np topper-block" onClick={handleTopperBlockClick}>
                <div style={{display: "flex"}}>
                    {topper.hostname ? (
                    <div className="block-img">
                        <img src={GetSafeImageUrl(`https://www.google.com/s2/favicons?domain=${topper.hostname}&sz=48`)} width="48" title={topper.hostname} alt={topper.hostname} />
                    </div>
                    ):("")}
                    <div className="topper-hostname">
                        <Markup style={{color: "#47BA77"}} markup={topper.hostname} type="html" trim={false} className="ae-line-clamp-3"/>
                    </div>
                </div>
                <div className='topper-results'>
                    <div>
                        {   topper.links.length > 1 ? 
                            <Text id="newSearch.results" fields={{ count: topper.links.length }}>{topper.links.length} results</Text> : 
                            <Text id="newSearch.result" fields={{ count: topper.links.length }}>{topper.links.length} result</Text>
                         }
                    </div>
                    {topper.links.length > 1 ? (
                        <div className='expand-collapce-wrapper' onClick={toggleExpanded}>
                            {   expanded.value ?
                                <div className="topper-see-more-less"><div className='seeless-circle'></div>&nbsp;<Text id="newSearch.seeLessToppers">See less</Text></div> : 
                                <div className="topper-see-more-less"><div className='seemore-circle'></div>&nbsp;<Text id="newSearch.seeMoreToppers">See more</Text></div>
                            }
                        </div>
                    ) : ("")}
                </div>
                <div style={{display: "flex", flexFlow: "column"}}>
                {
                    topper.links.map((l, ix) => {
                        let imga = [];
                        if(l.img) {
                            imga.push(
                                <div>
                                    <img className='topper-link-image' src={GetSafeImageUrl(l.img)} alt=""/>
                                </div>
                            );
                        }
                        else {
                            imga.push(<div style={{minWidth: "40px", maxWidth: "40px"}}></div>)
                        }
                        let dispStr = (ix == 0 || expanded.value) ? "flex" : "none"
                        return(
                            <div style={{display: dispStr, flexFlow: "row", alignItems: "flex-start", justifyContent: "space-between"}}>
                                <div className="topper-link ae-line-clamp-1"><a target="none" href={l.url}><Markup markup={l.name} type="html" trim={false}/></a></div>
                                {imga}
                            </div>
                        )
                    })
                }
                </div>
            </div>
        </div>
  )
}
